// Jotai-based chart toggle system for toggling all charts simultaneously
import { useAtom } from 'jotai';
import { allChartsOpenAtom } from './jotaiAtoms';
import { useEffect } from 'react';

/**
 * Hook to access and control chart toggle state
 * @returns {Object} Object containing allChartsOpen state and toggleAllCharts function
 */
export const useChartToggle = () => {
  const [allChartsOpen, setAllChartsOpen] = useAtom(allChartsOpenAtom);

  const toggleAllCharts = (shouldOpen) => {
    setAllChartsOpen(shouldOpen);
  };

  return { allChartsOpen, toggleAllCharts };
};

/**
 * Hook to listen for chart toggle state changes
 * @param {Function} callback - Function to call when state changes
 * @returns {Function} Cleanup function (no-op for Jotai, kept for API compatibility)
 */
export const useChartToggleListener = (callback) => {
  const { allChartsOpen } = useChartToggle();

  // Use useEffect to call callback when allChartsOpen changes
  useEffect(() => {
    callback(allChartsOpen);
  }, [allChartsOpen, callback]);

  // Return no-op cleanup function for API compatibility
  return () => {};
};
